import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { EmployerAdmin,
  EmployerAdminCreateRequest,
  EmployerAdminCreateResponse } from '../../types/employer/EmployerAdmin';
import { PagedResponse, ResponseData } from '../../types/api';

const URL = '/v2/admin/employer-admins';

class EmployerAdminService {
  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<EmployerAdmin>> {
    return axios.get(URL, config);
  }

  static create(
    data: EmployerAdminCreateRequest,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<ResponseData<EmployerAdminCreateResponse>>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<void> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { EmployerAdminService };
